const getStatusColor = (isViolation) => {
  if (isViolation) return 'var(--color-error50)';

  return 'var(--color-success60)';
};
export default getStatusColor;
